import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export function StatusPill({ status, className }) {
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-[10px] rounded border uppercase tracking-wider font-semibold",
        `status-${status}`,
        className
      )}
    >
      {(status || "").replace("_", " ")}
    </span>
  );
}

export function PriorityPill({ priority, className }) {
  return (
    <span
      data-testid={`priority-pill-${priority}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-[10px] rounded border uppercase tracking-wider font-semibold",
        `priority-${priority}`,
        className
      )}
    >
      {priority}
    </span>
  );
}

export function KpiCard({ label, value, sub, icon: Icon, accent, testId }) {
  return (
    <div data-testid={testId} className="border border-border bg-card rounded-md p-5 flex flex-col gap-3 hover:-translate-y-0.5 transition-transform">
      <div className="flex items-center justify-between">
        <div className="eyebrow text-muted-foreground">{label}</div>
        {Icon && <Icon size={18} className={accent || "text-muted-foreground"} weight="regular" />}
      </div>
      <div className="text-3xl font-semibold tracking-tight display leading-none">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mono">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-start justify-between mb-6 gap-4">
      <div>
        <div className="eyebrow text-muted-foreground mb-1">Workspace</div>
        <h1 className="display text-3xl md:text-4xl font-semibold tracking-tighter">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", subtitle, action }) {
  return (
    <div className="border border-dashed border-border rounded-md p-12 text-center flex flex-col items-center gap-2">
      <div className="text-base font-medium">{title}</div>
      {subtitle && <div className="text-sm text-muted-foreground max-w-md">{subtitle}</div>}
      {action}
    </div>
  );
}
